import { render, staticRenderFns } from "./OdontogramaForm.vue?vue&type=template&id=72bc9cb9"
import script from "./OdontogramaForm.vue?vue&type=script&lang=js"
export * from "./OdontogramaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports